import throttle from "lodash-es/throttle";
import classNames from "classnames";
import * as React from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { Or } from "source/app/domain/Or";
import { NavigateTo } from "../../Routing/RouterNavigationTarget";
import { StyleClass } from "../Styles/CSS";
import * as styles from "./Hyperlink.css";
import { ArrayUtils } from "source/app/services/ArrayUtils";
import { Sounds } from "source/app/services/Sound/Sounds";

interface HyperlinkOptions {
    id?: string;
    classes?: string;
    className?: string;
    title?: string;
    ariaLabel?: string;
    whenClicked: THyperlinkHandler;
    children?: any;
    hover?: boolean;
    tooltip?: string;
    to?: string;
}

const Hyperlink = (props: HyperlinkOptions) => {
    const hoverStyleClass = StyleClass(`linkHover_sharedStyle`, {
        ":hover": { textShadow: "0px 0px 7px gold" },
    });

    const handleMouseEnter = throttle(() => {
        const sound = GetHyperlinkHoverSound();
        sound.Play({ volume: 0.3, allowConcurrent: true });
    }, 200);

    const isExternalLink = props.to?.startsWith(`http`);
    const linkTarget = isExternalLink ? `_blank` : `_self`;
    const isActionOnly = !props.to;
    const linkClassName = classNames(props.classes, props.className, {
        [styles.ifDesktop_Transition]: !IsMobileDevice(),
        [hoverStyleClass]: Or(props.hover, true),
    });

    const activate = (
        event: React.MouseEvent<HTMLElement, MouseEvent>
    ) => {
        props.whenClicked(event);

        if (props.to) {
            if (isExternalLink) {
                return;
            }

            console.log(
                `[Routing] hyperlink navigating to '${props.to}'`
            );

            NavigateTo(props.to);
        }

        event.preventDefault();
    };

    if (isActionOnly) {
        return (
            <button
                id={props.id ? props.id : ""}
                aria-label={props.ariaLabel}
                className={classNames(styles.actionOnlyButton, linkClassName)}
                title={props.title}
                type="button"
                onClick={activate}
                data-tip={props.tooltip}
                onMouseEnter={handleMouseEnter}
            >
                {props.children}
            </button>
        );
    }

    return (
        <a
            id={props.id ? props.id : ""}
            aria-label={props.ariaLabel}
            className={linkClassName}
            title={props.title}
            href={props.to}
            target={linkTarget}
            style={{ touchAction: `manipulation` }}
            onClick={activate}
            data-tip={props.tooltip}
            onMouseEnter={handleMouseEnter}
        >
            {props.children}
        </a>
    );
};

export default Hyperlink;

export type THyperlinkHandler = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
) => void;

function GetHyperlinkHoverSound() {
    return ArrayUtils.GetRandomElement([
        Sounds.metal_keys_jangling_1,
        Sounds.metal_keys_jangling_2,
        Sounds.metal_keys_jangling_3,
        Sounds.metal_keys_jangling_4,
    ]);
}
